// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7193":"6cbcb689","8762":"ef1ac2b6"}[chunkId] + ".chunk.css";
};